export default __webpack_public_path__ + "static/media/AnotherDay.8e1c5661.mp3";